// extracted by mini-css-extract-plugin
export var big = "field_wrapper-module--big--mqpa1";
export var element_label = "field_wrapper-module--element_label--efk6h";
export var error_icon = "field_wrapper-module--error_icon--eTrPL";
export var error_message = "field_wrapper-module--error_message--U+LvE";
export var hint_message = "field_wrapper-module--hint_message--j8y38";
export var label_wrapper = "field_wrapper-module--label_wrapper--5pzUh";
export var large = "field_wrapper-module--large--sY5+8";
export var medium = "field_wrapper-module--medium--juVBK";
export var regSmall = "field_wrapper-module--reg-small--BLMj8";
export var wrapper = "field_wrapper-module--wrapper--EpZUI";